export default __webpack_public_path__ + "static/media/1092.9e672ee0.png";